import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { adminStatsService } from '../../../services/adminStatsService';
import { useSeasonContext } from '../../../context/SeasonContext';

const LeaderboardItemBlock = ({ block, onUpdate, onDelete }) => {
  const [players, setPlayers] = useState([]);
  const { selectedSeason } = useSeasonContext();

  useEffect(() => {
    if (selectedSeason?.id) {
      fetchPlayers();
    }
  }, [selectedSeason?.id]);

  const fetchPlayers = async () => {
    try {
      const playerList = await adminStatsService.getPlayersForSeason(selectedSeason.id);
      setPlayers(playerList);
    } catch (error) {
      console.error('Error fetching players:', error);
    }
  };

  const handlePlayerChange = (playerName) => {
    const selectedPlayer = players.find(p => p.name === playerName);
    onUpdate(block.id, {
      player: playerName,
      team: selectedPlayer?.team || ''
    });
  };

  return (
    <div className="block-item leaderboard-block">
      <div className="block-header">
        <span>Leaderboard Entry</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <select
        value={block.player || ''}
        onChange={(e) => handlePlayerChange(e.target.value)}
        className="field-select"
      >
        <option value="">Select player</option>
        {players.map((player) => (
          <option key={player.name} value={player.name}>
            {player.name}
          </option>
        ))}
      </select>
      <input
        type="text"
        placeholder="Team"
        value={block.team || ''}
        disabled
        className="field-input"
      />
      <input
        type="text"
        placeholder="Stat"
        value={block.stat || ''}
        onChange={(e) => onUpdate(block.id, { stat: e.target.value })}
        className="field-input"
      />
      <input
        type="text"
        placeholder="Value"
        value={block.value || ''}
        onChange={(e) => onUpdate(block.id, { value: e.target.value })}
        className="field-input"
      />
    </div>
  );
};

export default LeaderboardItemBlock;
